module.exports = __webpack_public_path__ + "static/media/error-404.d3c57e3b.png";